import InstallReactPackageManagers from "../../../../contents/docs/integrate/_snippets/install-react-package-managers.mdx";
import CalloutBox from 'components/Docs/CalloutBox';
import * as React from 'react';
export default {
  InstallReactPackageManagers,
  CalloutBox,
  React
};